/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShareClaimRequestOneOf
 */
export interface ShareClaimRequestOneOf {
    /**
     * 
     * @type {string}
     * @memberof ShareClaimRequestOneOf
     */
    type: ShareClaimRequestOneOfTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ShareClaimRequestOneOf
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof ShareClaimRequestOneOf
     */
    level?: ShareClaimRequestOneOfLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShareClaimRequestOneOf
     */
    blockedModules?: Array<ShareClaimRequestOneOfBlockedModulesEnum>;
}


/**
 * @export
 */
export const ShareClaimRequestOneOfTypeEnum = {
    User: 'user'
} as const;
export type ShareClaimRequestOneOfTypeEnum = typeof ShareClaimRequestOneOfTypeEnum[keyof typeof ShareClaimRequestOneOfTypeEnum];

/**
 * @export
 */
export const ShareClaimRequestOneOfLevelEnum = {
    Ro: 'ro',
    Rw: 'rw'
} as const;
export type ShareClaimRequestOneOfLevelEnum = typeof ShareClaimRequestOneOfLevelEnum[keyof typeof ShareClaimRequestOneOfLevelEnum];

/**
 * @export
 */
export const ShareClaimRequestOneOfBlockedModulesEnum = {
    Comparisons: 'comparisons',
    Documents: 'documents',
    Photos: 'photos',
    Links: 'links',
    Tasks: 'tasks',
    Supplements: 'supplements',
    Forms: 'forms',
    Financials: 'financials',
    Emails: 'emails',
    Notes: 'notes'
} as const;
export type ShareClaimRequestOneOfBlockedModulesEnum = typeof ShareClaimRequestOneOfBlockedModulesEnum[keyof typeof ShareClaimRequestOneOfBlockedModulesEnum];


/**
 * Check if a given object implements the ShareClaimRequestOneOf interface.
 */
export function instanceOfShareClaimRequestOneOf(value: object): value is ShareClaimRequestOneOf {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function ShareClaimRequestOneOfFromJSON(json: any): ShareClaimRequestOneOf {
    return ShareClaimRequestOneOfFromJSONTyped(json, false);
}

export function ShareClaimRequestOneOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareClaimRequestOneOf {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'userId': json['userId'],
        'level': json['level'] == null ? undefined : json['level'],
        'blockedModules': json['blockedModules'] == null ? undefined : json['blockedModules'],
    };
}

export function ShareClaimRequestOneOfToJSON(json: any): ShareClaimRequestOneOf {
    return ShareClaimRequestOneOfToJSONTyped(json, false);
}

export function ShareClaimRequestOneOfToJSONTyped(value?: ShareClaimRequestOneOf | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'userId': value['userId'],
        'level': value['level'],
        'blockedModules': value['blockedModules'],
    };
}

